import { MessageCircle } from 'lucide-react';

const MessagesWhatsApp = () => (
  <section className="min-w-0 max-w-xl bg-sand-50 p-4 ring-1 ring-ink-900/10 sm:p-8">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-[11px] uppercase tracking-[0.18em] text-saffron-600 sm:text-xs sm:tracking-[0.22em]">
          Messaging
        </p>
        <h2 className="mt-2 font-display text-xl font-light text-ink-900 sm:text-2xl">
          WhatsApp Business
        </h2>
      </div>
      <span className="flex h-9 w-9 flex-none items-center justify-center bg-ink-900 text-saffron-400 sm:h-10 sm:w-10">
        <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </div>
    <p className="mt-2 text-sm leading-relaxed text-ink-700/80">
      Connect a WhatsApp Business account to send booking confirmations, templates and reminders
      from Spirara.
    </p>
    <span className="mt-5 inline-flex bg-ink-900/5 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-600">
      Coming soon
    </span>
  </section>
);

export default MessagesWhatsApp;
